/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ApiHeaders } from './headers';
import { RestResponse } from '../model';
import { SearchableProvider } from '../model/interface/searchable.provider';
import { Preference } from '../model/preference';

@Injectable()
export class PreferenceProvider implements SearchableProvider {

  constructor(
    private http: HttpClient
  ) { }

  getPreferences(): Observable<RestResponse> {
    return this.http
      .get<RestResponse>(`${environment.API_URL}/api/preference/list`,
        ApiHeaders.getOptions());
  }

  getSearchType(): string {
    return 'PREFERENCE';
  }

  save(id: string, field: string, value: any): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(`${environment.API_URL}/api/preference/${id}/field`, {
        FIELD: field,
        VALUE: value
      }, ApiHeaders.getOptions());
  }

  savePreference(preference: Preference): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(`${environment.API_URL}/api/preference`, preference, ApiHeaders.getOptions());
  }

  getPreference(id: string): Observable<RestResponse> {
    return this.http
      .get<RestResponse>(`${environment.API_URL}/api/preference/${id}`, ApiHeaders.getOptions());
  }

  search(query?: string, id?: string, nonBank?: boolean, lsp?: boolean, page?: number): Observable<RestResponse> {
    return this.getPreferences();
  }

  deletePreference(preference: Preference): Observable<RestResponse> {
    return this.http
      .delete<RestResponse>(`${environment.API_URL}/api/preference/${preference.ID}`, ApiHeaders.getOptions());
  }
}
